import { useMemo } from 'react';
import { useUrlFilters } from '@/lib/hooks/useUrlFilters';
import type { AttendanceFilters } from '../types';

const defaults: AttendanceFilters = {
  limit: 10,
  page: 0,
  orderBy: 'arrivedAt',
  order: 'desc',
  'createdAt.min': undefined,
  'createdAt.max': undefined,
  userId: undefined,
};

const numberFields: (keyof AttendanceFilters)[] = ['limit', 'page', 'userId'];

export function useAttendanceFilters(initialFilters: Partial<AttendanceFilters> = {}) {
  const mergedDefaults = useMemo(
    () => ({ ...defaults, ...initialFilters }),
    [initialFilters]
  );

  return useUrlFilters<AttendanceFilters>({ defaults: mergedDefaults, numberFields });
}
